export function setToken(token) {
  localStorage.setItem('token', token);
}
export function getToken() {
  return localStorage.getItem('token');
}
export function removeToken() {
  localStorage.removeItem('token');
}
export function getTokenExpiration(token) {
  if (!token) return 0;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  } catch {
    return 0;
  }
}
export function isTokenExpiringSoon(token, thresholdMs = 3 * 60 * 1000) {
  const exp = getTokenExpiration(token);
  const remainingTime = exp - Date.now();
  const remainingMinutes = Math.floor(remainingTime / (60 * 1000));
  
  // console.log(`[AUTH] Token expira en ${remainingMinutes} minutos. Threshold: ${thresholdMs/60000} minutos`);
  
  return remainingTime < thresholdMs;
} 